import { withState } from 'recompose';

export default withState('alert', 'updateAlert', null);
